import styled from 'styled-components';

import {
  BaseColumnWrap,
  CenteredSpaceWrap,
  PrimaryLink,
} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import Image from '@stencil/image';
import {textSizes} from '@stencil/build-theme';

export const DealsDiscoveySectionHeader = styled.div(
  props => `

    display:flex;
    position:sticky;
    top:0;
    border-bottom: 1px solid  ${props.theme.colors.goBrandBlue.light};
    background: #EFF3F8;
    justify-content: space-between;
    align-items: center;
    padding-bottom: ${props.theme.spacing.large};
    z-index: ${props.theme.misc.zIndex.small};
    padding: ${props.theme.spacing.xlarge};
    border-radius: ${props.theme.misc.borderRadius.custom(17)};
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `,
);

export const OfferImgWrap = styled(Image)(
  props => `
  height: 1.5rem;
  width: auto;
  margin-right: ${props.theme.spacing.base};
  `,
);

export const DiscountTagBlock = styled.div(
  props => `
  display:flex;
  background-color: ${props.bgColor || props.theme.colors.goPurple.light};
  align-items:center;
  padding:${props.theme.spacing.small} ${props.theme.spacing.base};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  border-color: ${props.borderColor};
  color: ${props.textColor || props.theme.colors.goPurple.base};
  font-size:${props.theme.font.custom(11)};
  font-weight: 600;
  margin-bottom : 0.5rem;
`,
);

export const PromoDiscountBlock = styled.div(
  props => `
  display:flex;
  background-color: ${props.bgColor || props.theme.colors.goBrandOrange.light};
  align-items:center;
  padding:${props.theme.spacing.small} ${props.theme.spacing.base};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  border-color: ${props.borderColor};
  color: ${props.textColor || props.theme.colors.goBrandOrange.base};
  font-size:${props.theme.font.custom(11)};
  font-weight: 600;
  border:0.1rem dashed ${props.borderColor || props.theme.colors.goBrandOrange.base};
`,
);

export const DiscountAdditionalTextBlock = styled.div(
  props => `
  color: ${props.theme.colors.downriver.medium};
`,
);

export const HeaderPara = styled.p(
  props => `
    font-size: ${props.theme.font.custom(18)};
    font-weight: 600;
    `,
);

export const DiscountingPara = styled(CenteredSpaceWrap)(
  props => `
    margin-bottom: ${props.theme.spacing.base};
    `,
);

export const GoTribe_Img = styled(Image)(
  props => `
    width:9.1rem;
    height: 1.6rem;
    object-fit: contain;
    `,
);

export const SBI_Img = styled(Image)(
  props => `
      width:2.5rem;
      height: 1rem;
      margin-right:${props.theme.spacing.small};
      object-fit: contain;
      `,
);

export const DealsDiscoveryBodyWrap = styled.div(
  props => `
    padding: ${props.theme.spacing.custom(17)} ${props.theme.spacing.custom(12)};
    max-height:700px;
    `,
);

export const FotterBase = styled.div(
  props => `
    display:flex;
    width:100%;
    padding: ${props.theme.spacing.custom(12)} ${props.theme.spacing.custom(24)};
    justify-content:space-between;
    position:fixed;
    bottom:0;
    background: #FFFFFF;
    box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.24);
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    `,
);

export const Total_saving_span = styled.span`
  ${textSizes.BaseW3}
  color: #0EA90E;
  margin-bottom: ${props => props.theme.spacing.custom(12)};
`;

export const Total_saving_Amount_span = styled.span(
  props => `
    color: #0EA90E;
    font-size:${props.theme.font.custom(14)};
    margin-bottom:${props.theme.spacing.custom(12)};
    font-weight: 600;
    `,
);

export const Fianl_Price = styled.span`
  ${textSizes.BaseW3}
  margin-bottom:${props => props.theme.spacing.custom(1)};
`;

export const PerNight_Text = styled.span(
  props => `
    color: #777777;
    `,
);

export const Right_Side_Fotter = styled(BaseColumnWrap)(
  props => `
    align-items:end;
    `,
);

export const GoTribe_Wrap = styled.div(
  props => `
    display:flex;
    flex-direction: column;
    padding: ${props.theme.spacing.base};
    border-bottom: 1px solid #EAEAEA;
    `,
);

export const Green_Amount = styled.span`
  ${textSizes.BaseW3}
  color:#18A160;
  margin-bottom: 0.5rem;
`;

export const Additional_Text = styled.p(
  props => `
    margin-top: ${props.theme.spacing.base};
    `,
);

export const Discount_Tag_Wrap = styled.span`
  ${textSizes.SmallW3}
  background: #FBF1FF;
  border-radius: 10.5px;
  display: flex;
  align-items: center;
  padding: ${props => props.theme.spacing.small} ${props => props.theme.spacing.custom(8)};
  color: #9d3de8;
`;

export const PromoCodeHeader = styled.p`
  ${textSizes.SmallW3}
  display:flex;
  align-items: center;
  margin-bottom: ${props => props.theme.spacing.custom(12)};
  color: #ff6d38;
`;

export const PromoCodeBody = styled.div(
  props => `
      display:flex;
      flex-direction: column;
      padding:${props.theme.spacing.custom(12)} ${props.theme.spacing.custom(10)};
      `,
);

export const PromoBank_Card = styled.ul(
  props => `
          display:flex;
          flex-direction: column;
          margin-bottom:${props.theme.spacing.custom(50)};
          li{
            cursor: pointer;
            display:flex;
            width:100%;
            border: 1px solid #E1E7EE;
            border-radius: 8px;
            margin-bottom:${props.theme.spacing.custom(8)};
            padding: ${props.theme.spacing.base};
            &:last-child{
                margin-bottom:${props.theme.spacing.custom(30)};;
              }
          }
          `,
);

export const PromoBankDetails = styled.p(
  props => `
    display:flex;
    justify-content: space-between;
    margin-bottom:${props.theme.spacing.custom(11)};
    align-items: center;
    `,
);

export const BankDetails_OuterWrap = styled.p(
  props => `
      display:flex;
      width:100%;
      flex-direction: column;
      margin-left:${props.theme.spacing.base};
      `,
);

export const Final_Pricing = styled.span`
  ${textSizes.BaseW3}
  color:${props => (props.isApplied ? '#2BAC36' : '')};
`;

export const BankWrap = styled.span`
  ${textSizes.SmallW3}
  display:flex;
  align-items: center;
  background: #e9f6ea;
  border-radius: 4px;
  padding: ${props => props.theme.spacing.custom(2)} ${props => props.theme.spacing.small};
  color: #18a160;
  background: ${props => (props.isApplied ? '#fff' : '#E9F6EA')};
`;

export const RadioButtonLabel = styled.label(
  props => `
      position: absolute;
    //   top: 2rem;
    //   left: 1rem;
      width: 1.7rem;
      height: 1.6rem;
      border-radius: ${props.theme.misc.borderRadius.round};
      background: ${props.theme.colors.goWhite.base};
      border: ${props.theme.misc.border.base} solid ${props.theme.colors.downriver.medium};
  `,
);

export const RadioButton = styled.input(
  props => `
      opacity: 0;
      z-index: 1;
      border-radius: ${props.theme.misc.borderRadius.round};
      border: ${props.theme.misc.border.base} solid ${props.theme.colors.downriver.base};
      width: 1.6rem;
      height: 1.6rem;
      margin-right: ${props.theme.spacing.small};
      cursor: pointer;
      &:hover ~ ${RadioButtonLabel} {
      background: ${props.theme.colors.goWhite.base};
      &::after {
          content: "";
          display: block;
          border-radius: ${props.theme.misc.borderRadius.round};
          width: 1rem;
          height: 1rem;
          margin: ${props.theme.spacing.xsmall};
          background: ${props.theme.colors.goBrandBlue.base};
      }
      }
      &:checked + ${RadioButtonLabel} {
      // background: ${props.theme.colors.goWhite.base};
      // color: ${props.theme.colors.goBrandBlue.base}
      border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.base};
      &::after {
          content: '';
          display: block;
          border-radius: ${props.theme.misc.borderRadius.round};
          width: 1rem;
          height: 1rem;
          margin: ${props.theme.spacing.xsmall};
          background: ${props.theme.colors.goBrandBlue.base};
      }
      }
  `,
);

export const PromoCodeRemoveLink = styled(PrimaryLink)(
  props => `
    color: ${props.theme.colors.goRed.base};
    background-color: rgb(255, 255, 255);
    margin-left: 1.2rem;
    border: 0px;
    border-radius: 0.8rem;
      font-weight: 600;
    color: rgb(255, 58, 92);
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    padding: 0.4rem 0.7rem;
  `,
);
